import {Component, EventEmitter, Inject, OnInit, Output} from '@angular/core';
import {AgendaEvent} from '../../../../../../domain/agenda/model/agenda-event';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
             selector: 'app-delete-event-dialog',
             templateUrl: './delete-event-dialog.component.html'
           })
export class DeleteEventDialogComponent implements OnInit {

  @Output() deleteEvent: EventEmitter<AgendaEvent> = new EventEmitter<AgendaEvent>();

  event: AgendaEvent;

  constructor(@Inject(MAT_DIALOG_DATA) public data,
              public formDialogRef: MatDialogRef<DeleteEventDialogComponent>) {
  }

  ngOnInit(): void {
    this.event = this.data.event;
  }

  public delete(): void {
    this.deleteEvent.emit(this.event);
    this.formDialogRef.close();
  }

  public close(): void {
    this.formDialogRef.close();
  }

}
